const ProviderId = {
    LENDINGCLUB: "lendingclub",
    PROCEED: "proceed",
    SYNCHRONY: "synchrony",
    HFD: "hfd",
    CLARITYPAY: "claritypay",
}

export default ProviderId
